import React from "react";
import { Outlet } from "react-router-dom";

const GatepassPage: React.FC = () => {
  return (
    <div data-testid="gatepass">
      <Outlet />
    </div>
  );
};

export default GatepassPage;
